import './Header.css'
import Icon from './Icon'
import { Settings } from './Settings'
import { audioEffects } from '../utils/audioEffects'
import { useState, useRef, useEffect } from 'react'

interface HeaderProps {
  onShowHint?: (hint: string) => void
}

function Header({ onShowHint }: HeaderProps = {}) {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const settingsButtonRef = useRef<HTMLButtonElement | null>(null)

  // Initialize mute state from audioEffects
  useEffect(() => {
    setIsMuted(audioEffects.isMutedState())
  }, [])

  const toggleMute = () => {
    const newMutedState = !isMuted
    
    if (newMutedState) {
      // Play mute sound before muting
      audioEffects.playMuteBoop()
      // Set muted state after a short delay to let the sound play
      setTimeout(() => {
        audioEffects.setMuted(true)
        setIsMuted(true)
      }, 50)
    } else {
      // Unmute first, then play unmute sound
      audioEffects.setMuted(false)
      setIsMuted(false)
      // Small delay to ensure unmute state is set before playing sound
      setTimeout(() => {
        audioEffects.playUnmuteBoop()
      }, 50)
    }
  }

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <span className="logo-text">LV</span>
        </div>
        <nav className="nav">
          {/* <a href="#" className="nav-link">Home</a> */}
          {/* <a href="#" className="nav-link">About</a> */}
          {/* <a href="#" className="nav-link">Projects</a> */}
          <div className="header-buttons">
            <button 
              className="mute-toggle" 
              onClick={toggleMute}
              onMouseEnter={() => audioEffects.playPop()}
              aria-label={isMuted ? 'Unmute sounds' : 'Mute sounds'}
              title={isMuted ? 'Unmute sounds' : 'Mute sounds'}
            >
              <Icon 
                name={isMuted ? 'volumeMute' : 'volume'} 
                size={20}
              />
            </button>
            <button 
              ref={settingsButtonRef}
              className="settings-button" 
              onClick={() => {
                audioEffects.playPanelOpen()
                setIsSettingsOpen(!isSettingsOpen)
              }}
              onMouseEnter={() => audioEffects.playPop()}
              aria-label="Open settings"
              title="Theme & color settings"
            >
              <Icon 
                name="settings" 
                size={20}
              />
            </button>
          </div>
        </nav>
      </div>
      <Settings
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        buttonRef={settingsButtonRef}
        onShowHint={onShowHint}
      />
    </header>
  )
}

export default Header
